import { Grid } from "@material-ui/core";
import React, { } from "react";
import { DataCard } from "@ofqual/portal-components/components/DataCard/DataCard";
import { ProfessionalMembershipModel } from "../../domain/ProfessionalMembershipModel";

export const ProfessionalMemberships: React.FC<{
  hasProfessionalMemberships: boolean,
  professionalMemberships: ProfessionalMembershipModel[];
}> = ({ hasProfessionalMemberships, professionalMemberships }) => {

  return (
    <>
      <div style={{ overflowWrap: 'break-word' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <DataCard
              showHeading={false}
              heading=""
              items={[
                {
                  itemType: "DEFAULT",
                  key:
                    "Are you currently a member of any professional bodies, associations or institutes?",
                  value: hasProfessionalMemberships ? "Yes" : "No",
                },
              ]}
              hasAction={false}
              actionDescription={null}
              actionButtonText={null}
              actionFunction={null}
              headingComponent={"h1"}
            />
            <br />
            {hasProfessionalMemberships ? (
              professionalMemberships.map((professionalMembership, index) => (
                <>
                  {index > 0 ? <br /> : <></>}
                  <DataCard
                    showHeading={true}
                    heading={professionalMembership.organisationName}
                    items={[
                      {
                        itemType: "DEFAULT",
                        key: "Organisation name",
                        value: professionalMembership.organisationName,
                      },
                      {
                        itemType: "DEFAULT",
                        key: "Membership type",
                        value: professionalMembership.membershipType,
                      },
                      {
                        itemType: "DEFAULT",
                        key: "Year joined",
                        value:
                          professionalMembership.yearJoined?.toString() ?? "",
                      },
                    ]}
                    hasAction={false}
                    actionDescription={null}
                    actionButtonText={null}
                    actionFunction={null}
                    headingComponent={"h1"}
                  />
                </>
              ))
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );
};
